import styled, { css } from "styled-components";
import { transparentize } from "polished";

interface HorseContainerProps {
  isActive: boolean;
}

interface HorseDescriptionProps {
  isActive: boolean;
  isScratched: boolean;
  isIOSApp: boolean;
}

interface RunnerNameProps {
  isScratched: boolean;
}

export const HorseContainer = styled.button<HorseContainerProps>`
  background-color: ${({ theme }) => theme.colorTokens.content.onDark};
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 16px 12px;
  outline: none;
  ${({ isActive }) =>
    isActive &&
    css`
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 2px;
        background-color: ${({ theme }) => theme.colorTokens.content.link};
      }
    `};
`;

export const RunnerNumberContainer = styled.div`
  min-width: 20px;
  height: 20px;
  margin-right: 4px;
`;

export const HorseDescription = styled.div<HorseDescriptionProps>`
  white-space: nowrap;
  font-family: ${({ theme }) => theme.fonts.medium};
  display: flex;
  font-size: 14px;
  color: ${({ isActive, theme }) =>
    isActive
      ? theme.colorTokens.content.link
      : theme.colorTokens.content.onLight};
  ${({ isScratched, isActive, theme }) =>
    isScratched &&
    css`
      color: ${isActive
        ? theme.colorTokens.component.button.buttonLink.background.active
        : theme.colorTokens.content.subtle3};
    `};

  /* Hack to fix vertical alignment on ios app and safari */
  ${({ isIOSApp }) =>
    !isIOSApp &&
    css`
      height: 16px;
    `}

  span {
    ${({ isIOSApp }) =>
      isIOSApp &&
      css`
        height: 13px;
        line-height: 12px;
        align-self: center;
      `}
  }
`;

export const HorseSwitcherWrapper = styled.div`
  background-color: ${({ theme }) => theme.colorTokens.content.onDark};
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  position: sticky;
  top: 0;
  left: 0;
  z-index: 99;
  box-shadow:
    0 2px 4px
      ${({ theme }) =>
        transparentize(0.94, theme.colorTokens.background.secondary)},
    0 1px 2px
      ${({ theme }) =>
        transparentize(0.92, theme.colorTokens.background.secondary)};
`;

export const RunnerName = styled.span<RunnerNameProps>`
  margin-right: 4px;
  ${({ isScratched }) =>
    isScratched &&
    css`
      text-decoration: line-through;
    `}
`;

export const ScrollAreaDisabled = styled.div`
  display: flex;
  overflow: hidden;
  pointer-events: none;
`;
